<template>
  <el-form :model="form" :rules="rules" ref="form">
    <div class="d-flex flex-wrap align-items-end justify-content-between flex-gap-10">
      <span>Шаг {{step.ordinalNumber}}. {{step.stepName}}</span>
      <div v-if="$isAccess($userRoles.Admin, $userRoles.Dispatcher)">
        <el-button v-if="isEdited" type="primary" size="medium" :loading="updateProgress" @click="onSave">
          Сохранить
        </el-button>
        <el-button v-else size="medium" @click="isEdited=true" :loading="updateProgress">
          Изменить
        </el-button>
      </div>
    </div>
    <el-form-item prop="comment" class="mt-3">
      <el-input type="textarea"
                class="w-100"
                :rows="4"
                maxlength="200"
                show-word-limit
                :disabled="!isEdited"
                v-model="form.comment"
                resize="none"/>
      <span class="floating-span" :class="{ 'floating-span_active': $notEmpty(form.comment) }">Комментарий</span>
    </el-form-item>
  </el-form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { MESSAGES } from '@/commons/constants/errorMessages';

export default {
  props: {
    step: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    isEdited: false,
    form: {
      comment: '',
      state: null,
    },
    rules: {
      comment: [
        { required: true, message: MESSAGES.REQUIRED, trigger: 'change' },
      ],
    },
  }),
  computed: {
    ...mapGetters({
      item: 'orders/item',
      updateProgress: 'orders/updateProgress',
    }),
  },
  methods: {
    ...mapActions({
      updateStep: 'orders/updateStep',
    }),
    fillForm() {
      this.form.comment = this.step.customerComment || '';
      this.form.state = this.step.stepState;
    },
    onSave() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const { visitOrderId: id } = this.item;
          const stepNumber = this.step.ordinalNumber;
          const data = {
            ...this.form,
          };
          this.updateStep({ id, stepNumber, data })
            .then(() => {
              this.isEdited = false;
            });
        }
      });
    },
  },
  created() {
    this.fillForm();
  },
};
</script>
